export const SnomedExpression = {
    TipoDeCama: '^2051000013106',
    Equipaminetos: '^2061000013108',
    Especialidades: '<<394658006',
    Genero: '703118005 OR 703117000'
};
